import React from 'react';

import { EMPTY_VALUE_MESSAGE } from '../QuestionnaireViewOnlyContent/QuestionnaireViewOnlyContent';
import { CONTENT_GROUP_DETAIL_KEY, CONTENT_GROUP_TYPE } from '../../../../constants/cycleDetail';

import Diagram from '../../../../design-system/Diagram/Diagram';
import RichTextArea from '../../../../design-system/RichTextArea/RichTextArea';
import TagsContentSection from '../TagsContentSection/TagsContentSection';
import FormContentSection from '../FormContentSection/FormContentSection';
import StepsContentSection from '../StepsContentSection/StepsContentSection';
import SettingsViewOnlyForm from '../../../CustomizeGoalPage/SettingsForm/SettingsViewOnlyForm/SettingsViewOnlyForm';
import VariablesContentSection from '../VariablesContentSection/VariablesContentSection';
import RequirementsContentSection from '../RequirementsContentSection/RequirementsContentSection';

const StageFormContentGroup = ({
    group,
    groupFormData,
    setGroupFormData = () => {},
    isEditable = false, // if false, looks as disabled form
    isViewOnly = false, // if false, looks in format question - answer
}) => {
    const { label, type, details } = group;

    const key = CONTENT_GROUP_DETAIL_KEY[type];
    const content = details?.[key];

    const editableGroupsProps = {
        groupFormData: isViewOnly ? content : groupFormData,
        setGroupFormData: isViewOnly ? () => {} : setGroupFormData,
        isEditable: isViewOnly ? false : isEditable,
    };

    return (
        <>
            {type === CONTENT_GROUP_TYPE.text && (
                <RichTextArea
                    value={content}
                    previewOnly
                    autoExpand
                    isBorderHidden
                    previewMinHeight={30}
                />
            )}

            {type === CONTENT_GROUP_TYPE.diagram && <Diagram code={content} name={label} />}

            {type === CONTENT_GROUP_TYPE.form && !isViewOnly && (
                <FormContentSection {...editableGroupsProps} />
            )}

            {type === CONTENT_GROUP_TYPE.form && isViewOnly && (
                <SettingsViewOnlyForm settings={content} emptyValueMessage={EMPTY_VALUE_MESSAGE} />
            )}

            {type === CONTENT_GROUP_TYPE.requirements && (
                <RequirementsContentSection {...editableGroupsProps} />
            )}

            {type === CONTENT_GROUP_TYPE.variables && (
                <VariablesContentSection {...editableGroupsProps} />
            )}

            {type === CONTENT_GROUP_TYPE.steps && <StepsContentSection {...editableGroupsProps} />}

            {type === CONTENT_GROUP_TYPE.tags && <TagsContentSection tag_groups={content} />}
        </>
    );
};

export default StageFormContentGroup;
